import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  backgroundGray: {
    backgroundColor: theme.palette.common.gray100,
    padding: theme.spacing(2, 4),
  },
  content: {
    backgroundColor: 'inherit',
    flex: '1 1 auto',
    overflowY: 'scroll',
    padding: theme.spacing(0, 5, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 3, 3),
    },
  },
  drawer: {
    backgroundColor: theme.palette.common.white,
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  drawerHeader: {
    backgroundColor: 'inherit',
    display: 'block',
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.common.white,
    },
  },
  // Opt-in via DrawerHeader's `showShadow`. A 1px rule rather than the drop
  // shadow the prop name implies — it matches DrawerFooter's `borderTop` and
  // the treatment design landed on in AXHE-4406.
  drawerHeaderDivider: {
    borderBottom: theme.customBorders.gray200,
  },
  footerContainer: {
    bottom: 0,
    position: 'sticky',
    right: 0, // to position w/in parent. not i.e. compatible
  },
  footerContainerDefault: {
    backgroundColor: 'inherit',
    borderTop: theme.customBorders.gray200,
    margin: theme.spacing(0, 5),
    padding: theme.spacing(2, 0, 3),

    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.common.white,
      margin: 0,
      padding: theme.spacing(2, 3, 3),
    },
  },
  footerContent: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      '& button': {
        flex: 1,
      },
      justifyContent: 'unset',
    },
  },
  headerIcon: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.blue100,
    borderRadius: '50%',
    display: 'inline-flex',
    height: 40,
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    width: 40,
  },
}));

export default useStyles;
